import { If } from '../../../Atoms/Conditionals';
import { TCouponDetails, TPricing } from '../../../S/pricing/types';
import { getIsITRPlan } from '../../utils/utils';
import { getDiscountValueText } from '../utils';

interface IOfferPricingCard {
  pricing: TPricing;
  originalPrice: number;
  productServiceType: string;
  coupon: TCouponDetails;
  idPrefix?: string;
}

export const OfferPricingCard: React.FC<IOfferPricingCard> = ({
  pricing,
  originalPrice,
  productServiceType,
  coupon,
  idPrefix,
}) => {
  const isItrPlan = getIsITRPlan(productServiceType);
  const strikedOffPrice = originalPrice;
  const discountedPrice = Math.floor(pricing.totalAmount - pricing.tax);
  const discountValue = getDiscountValueText(
    coupon,
    originalPrice,
    discountedPrice,
    isItrPlan
  );
  return (
    <>
      <div className="flex items-center">
        <p
          className="font-bold text-grey-900 text-s-32"
          id={idPrefix ? `${idPrefix}-price-discounted` : undefined}
        >
          ₹{Math.floor(discountedPrice).toLocaleString('en-IN')}{' '}
        </p>
        <If
          condition={
            Math.floor(discountedPrice) !== Math.floor(strikedOffPrice)
          }
        >
          <p
            className="font-light ml-2 pr-1 self-center strikethrough text-base -mb-1"
            id={idPrefix ? `${idPrefix}-price-original` : undefined}
          >
            ₹{Math.floor(strikedOffPrice).toLocaleString('en-IN')}
          </p>
          <p
            className="text-s-14 font-medium text-orange-300 ml-2 -mb-1"
            id={idPrefix ? `${idPrefix}-price-discount` : undefined}
          >
            {discountValue}
          </p>
        </If>
      </div>
      <p className="font-light text-s-14 -mt-1.5">
        offer price <span className="text-s-10">(excl. of taxes)</span>
      </p>
    </>
  );
};
